module.exports = __webpack_public_path__ + "img/四棵树乡.54a62d53.png";